import { RoutingSearchResult } from '~/features/workflow-routing/types';
import { everest } from '~/services/serviceInstances';

import {
  SearchRoutingApiArg,
  ServerRoutingSearchResponse,
} from '../../types/routings/routes';

type Request = SearchRoutingApiArg;

export const searchRouting = async (
  request: Request,
): Promise<RoutingSearchResult> => {
  const response: ServerRoutingSearchResponse = await everest.get(
    '/routing/search',
    {
      params: {
        pageSize: request.pageSize,
        currentPage: request.currentPage,
        searchString: request.searchString,
        orderBy: request.orderBy,
      },
    },
  );

  return {
    data: response.data.map((route) => ({
      id: route.id,
      workflowId: route.workflowId,
      routeName: route.routeName,
      status: route.status,
      instructions: route.instructions,
      createdDate: route.createdDate,
      modifiedDate: route.modifiedDate,
      createdById: route.createdById,
      modifiedById: route.modifiedById,
      versionNumber: route.versionNumber,
      createdByName: route.createdByName ?? null,
      modifiedByName: route.modifiedByName ?? null,
      publishedWorkflowId: route.publishedWorkflowId ?? null,
    })),
    totalRecords: response.totalRecords,
    totalPages: response.totalPages,
    currentPage: response.currentPage,
    pageSize: response.pageSize,
  };
};
